import CommuteTwoToneIcon from "@material-ui/icons/CommuteTwoTone";
import RestaurantTwoToneIcon from "@material-ui/icons/RestaurantTwoTone";
import WifiTwoToneIcon from "@material-ui/icons/WifiTwoTone";
import LocalBarTwoToneIcon from "@material-ui/icons/LocalBarTwoTone";
import MeetingRoomTwoToneIcon from "@material-ui/icons/MeetingRoomTwoTone";
import ImportantDevicesIcon from "@material-ui/icons/ImportantDevices";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";

const listData = [
  {
    text: "Transportation from BCN Airport to Hotel Mas Salagros",
    icon: <CommuteTwoToneIcon />,
  },
  {
    text: "Welcome Dinner at Hotel",
    icon: <RestaurantTwoToneIcon />,
  },
  {
    text: "Morning meeting incl basic AAVV",
    icon: <MeetingRoomTwoToneIcon />,
  },
  {
    text: "Premium wine activity, including pic-nic lunch at vineyards",
    icon: <LocalBarTwoToneIcon />,
  },
  {
    text: "Off-site Dinner Traditional Catalan, ",
    icon: <RestaurantTwoToneIcon />,
  },
  {
    text: "Specialised tour of the 22@ district in Barcelona",
    icon: <WifiTwoToneIcon />,
  },
  {
    text: "Digital Workshop - Design Thinking + coffee break",
    icon: <ImportantDevicesIcon />,
  },
  {
    text: "Lunch in an iconic restaurant in Barcelona, en-route to the Airport",
    icon: <FlightTakeoffIcon />,
  },
];

export default listData;
